module.exports = __webpack_public_path__ + "static/media/Welcome.b5dcb692.svg";